// React Imports
import { ReactElement } from "react";

// Third-Party Library Imports
import clsx from "clsx";

type HeadingProperties = {
  size: number;
  text: string;
  style?: { [key: string]: string };
  className?: string;
};

const Heading: React.FC<HeadingProperties> = ({
  size,
  text,
  style,
  className,
}: HeadingProperties): ReactElement => {
  switch (size) {
    case 1:
      return (
        <h1 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h1>
      );
    case 2:
      return (
        <h2 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h2>
      );
    case 3:
      return (
        <h3 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h3>
      );
    case 4:
      return (
        <h4 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h4>
      );
    case 5:
      return (
        <h5 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h5>
      );
    default:
      return (
        <h1 className={clsx("text-blue-400", className)} style={style}>
          {text}
        </h1>
      );
  }
};

export default Heading;
